import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  objectiveDataAIRedux: [],
};

export const objectiveDataAISlice = createSlice({
  name: "objectiveAI",
  initialState,
  reducers: {
    setObjectiveDataAIRedux: (state, action) => {
      const newObjectives = Array.isArray(action.payload) ? action.payload : [];
      // Append new objectives and deduplicate by id
      const updatedObjectives = [
        ...(state.objectiveDataAIRedux || []),
        ...newObjectives,
      ].filter(
        (obj, index, self) => index === self.findIndex((t) => t.id === obj.id)
      );
      state.objectiveDataAIRedux = updatedObjectives;
    },

    clearDataAIRedux: (state) => {
      state.objectiveDataAIRedux = [];
    },
  },
});

export const { setObjectiveDataAIRedux, clearDataAIRedux } =
  objectiveDataAISlice.actions;

export default objectiveDataAISlice.reducer;
